import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];
  const mode = properties.mode || 'aggregate';

  if (mode === 'aggregate') {
    const aggregations = properties.aggregations?.values;

    if (!aggregations || aggregations.length === 0) {
      errors.push({
        key: 'aggregations',
        message: 'At least one aggregation is required in aggregate mode',
      });
    } else {
      aggregations.forEach((agg: any, idx: number) => {
        if (!agg.field || agg.field.trim() === '') {
          errors.push({
            key: `aggregations.values[${idx}].field`,
            message: 'Field name is required',
          });
        }
        if (!agg.outputField || agg.outputField.trim() === '') {
          errors.push({
            key: `aggregations.values[${idx}].outputField`,
            message: 'Output field name is required',
          });
        }
      });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
